<template>
<section :class="`bck__${color}`">
    <div class="trail__content" :class="{'trail__content--small': content==='small'}">
        <div class="trail__section--heading" >
                <h3 v-if="title" class="trail__section--title" :class="{'u-color-white' : color === 'grey-dark'}">
                    {{title}}            
                </h3>
                <h4 v-if="subtitle" class="trail__section--subtitle" :class="{'u-color-white' : color === 'grey-dark'}">
                    {{subtitle}}
                </h4>
        </div>
      
      <slot></slot>
  </div>
</section>
    
</template>

<script>
export default {
    props:['title', 'subtitle', 'color', 'content']

}
</script>

<style lang="scss">
@import "../../style/main";
@import "../../style/page/trail";
.trail{
    &__section{
        &--heading{
            &:empty{
                margin-bottom: 0;
            }
            margin-bottom: 2.5rem;
            display: flex;
            flex-direction: column;
        }
        &--title{
            font-size: 2.6rem;
            text-transform: uppercase;
            font-weight: 700;
            color:$color-grey-75;
            letter-spacing: .6rem;
            transition: all .2s;
            padding: 0 2rem;
            margin-bottom: .8rem;
            text-align: center;
        }

        &--subtitle{
            font-size: 1.4rem;
            text-transform: uppercase;
            font-weight: 400;
            color: $color-grey-50;
            letter-spacing: .8rem;
            padding: 0 2rem;
            text-align: center;
        }
    }
}
</style>